import {SimplePageLayout} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {useOffersSelection} from '../hooks/useOffersSelection';

export const IndexPage = () => {
    const {
        selectedRecords,
        setSelectedRecords
    } = useOffersSelection();

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader selectedRecords={selectedRecords} setSelectedRecords={setSelectedRecords}/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordsTable selectedRecords={selectedRecords} setSelectedRecords={setSelectedRecords}/>
        </SimplePageLayout>
    );
};
